// Lazy load function
const lazyLoad = (path) => () => import(/* webpackChunkName: "[request]" */ `@/views/touch/${path}.vue`);

export default [
    // Touch
    {
        path: "/t-sales-order/create*",
        name: "touch-sales-order-create",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrder" },
        components: {
            content: lazyLoad('sales/touch-sales-order'),
        },
    },
    {
        path: "/t-sales-order/edit/:id*",
        name: "touch-sales-order-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrder" },
        components: {
            content: lazyLoad('sales/touch-sales-order'),
        },
    },
    {
        path: "/t-sales-order/review/:id*",
        name: "touch-sales-order-review",
        meta: { requiresAuth: true, applicationFeatureCode: "SalesOrder" },
        components: {
            content: lazyLoad('sales/touch-sales-order'),
        },
    },
]; 